import { render } from "./FormAddress.vue?vue&type=template&id=68d76ea2"
import script from "./FormAddress.vue?vue&type=script&lang=js"
export * from "./FormAddress.vue?vue&type=script&lang=js"

import "./FormAddress.vue?vue&type=style&index=0&id=68d76ea2&lang=scss"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__